import { Link } from 'react-router-dom';
import { useReveal } from '../lib/anim/useReveal';

export function CtaPanel() {
  const reveal = useReveal();

  return (
    <section
      className="py-24"
      style={{ background: 'var(--color-moment-bg)' }}
    >
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div ref={reveal.ref} {...reveal.props} className={reveal.props.className}>
          <h2
            className="text-3xl md:text-5xl font-bold leading-tight"
            style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--color-moment-ink)',
              letterSpacing: '-0.02em',
            }}
          >
            Start with Pilot — $149/mo
          </h2>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            {/* GOLD placement 5: gold dot scoped to $149/mo only */}
            <Link
              to="/signup?tier=pilot"
              className="btn-primary text-lg"
            >
              Start with Pilot —{' '}
              <span aria-hidden className="inline-block w-1.5 h-1.5 rounded-full bg-gold mx-2" style={{ background: 'var(--color-gold)' }} />
              $149/mo
            </Link>
          </div>

          <span
            className="block mt-5 text-sm"
            style={{ color: 'rgba(232, 234, 242, 0.5)', fontFamily: 'var(--font-body)' }}
          >
            Cancel any time. 30-day Hormozi gate.
          </span>
        </div>
      </div>
    </section>
  );
}
